import map from "lodash/fp/map";
import capitalize from "lodash/fp/capitalize";
import isNil from "lodash/fp/isNil";
import moment from "moment";
import constants from "../../core/constants";

class CorporateContractApprovalsPageTransform {
  constructor($state, $location) {
    "ngInject";
    this.$state = $state;
    this.fields = [
      { title: "Corporate Name", name: "corporateName" },
      { title: "Request Date", name: "createdAt" },
      { title: "Status", name: "statusName" },
      { title: "Account Manager", name: "createdByName" },
      { title: "Reviewed By", name: "reviewedByName" },
      { title: "Version", name: "version" },
      {
        title: "View Contract Version",
        name: "viewContractVersion",
        action: true,
        actionName: "View Contract Version",
        actionIcon: "visibility",
        onActionClick: (data) => {
          $location.url(
            `/corporate/${data.corporate._id}/?version=${data.version}`
          );
        },
      },
    ];
    this.filters = [
      {
        name: "status",
        title: "Status",
        icon: "people_outline",
        list: "corporateContractStatus",
      },
      {
        name: "date",
        title: "Select date",
        icon: "date_range",
        isDate: true,
        hasDate: false,
      },
      {
        name: "corporate",
        title: "Corporate",
        icon: "search",
        resource: "Corporate",
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.corporateName = item.corporate.name;
      item.createdByName = !isNil(item.created_by) ? item.created_by.name : "";
      item.reviewedByName = !isNil(item.reviewed_by)
        ? item.reviewed_by.name
        : "";
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      if (item.status === "pending") item.statusName = "Pending Approval";
      else item.statusName = capitalize(item.status);
      return item;
    };
    return map(format)(data);
  }
}

export default CorporateContractApprovalsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/corporateContractApprovals/corporateContractApprovals.transforms.js